import React, { createContext } from "react";
import "./App.css";
import NavBar from "./Components/NavBar";
import DetailPage from "./Pages/Detail";
import HeroPage from "./Pages/Hero";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Pages/Login";
import SignUp from "./Pages/SignUp";
import ForgotPassword from "./Pages/ForgotPassword";
import Payment from "./Pages/Payment/Payment";
import Banner from "./Pages/Banner/Banner";
import Detail from "./Components/Detail/Detail";
import MyCart from './Pages/Payment/MyCart';
import Scadual from "./Pages/Payment/Scadual";
import DigitalSection from "./Templates/HeroPage/DigitalSection";

const stateContext = createContext();

function App() {
  const [showModal, setShowModal] = React.useState(0);
  
  return (
    <BrowserRouter>
      <stateContext.Provider value={{showModal, setShowModal}}>
        <NavBar showModal={showModal} setShowModal={setShowModal}/>
      <Routes>
        <Route path="/" element={<HeroPage />} />
        <Route path="/detail" element={<DetailPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/payment" element={<Payment />} >
          <Route path="cart" element={<MyCart />} />
          <Route path="scadual" element={<Scadual />} />
        </Route>
        <Route path="/digital" element={<DigitalSection />} />
        <Route path="/banner" element={<Banner />} />
        <Route path="/details" element={<Detail />} />
      </Routes>
      </stateContext.Provider>
    </BrowserRouter>
  );
}

export {stateContext};
export default App;
